"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleSearchConsoleListSites = exports.googleSearchConsoleListSitesResultSchema = exports.googleSearchConsoleListSitesArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleSearchConsoleListSitesArgsSchema = zod_1.z.object({});
exports.googleSearchConsoleListSitesResultSchema = zod_1.z.object({
    sites: zod_1.z.array(zod_1.z.object({
        siteUrl: zod_1.z.string().describe('The URL of the Search Console property'),
        permissionLevel: zod_1.z.string().describe('The permission level for this property'),
    })),
});
exports.googleSearchConsoleListSites = (0, common_1.createToolMetadata)({
    id: 'googleSearchConsoleListSites',
    displayName: 'Google Search Console List Sites',
    displayDescription: 'List all verified Google Search Console properties for the connected account, including Domain and URL-prefix properties with their permission levels.',
    category: 'seo',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'search',
    argsSchema: exports.googleSearchConsoleListSitesArgsSchema,
}, exports.googleSearchConsoleListSitesResultSchema);
